module.exports = __webpack_public_path__ + "media/images/jpool-49eef4eb.png";